
import { DanaStandardReturnOrderActions } from "@dana/Store/Data/StandardReturns/Reducers/GetStandardReturnOrderReducer";
import { ApiHandler, createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

export interface ResetStandardReturnFlagParameter  {
    reset:boolean
}
type HandlerType = Handler<ResetStandardReturnFlagParameter,
    DispatchProp<DanaStandardReturnOrderActions>
>;

export const DispatchSetParameters: HandlerType = props => {
    props.dispatch({
        type: "StandardReturn/Init"
    } as any);
};
export const chain = [DispatchSetParameters];

const resetStandardReturnState = createHandlerChainRunner(chain, "ResetStandardReturnStateHandler");
export default resetStandardReturnState;